import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter,mapTo, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _isAuthenticated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    protected readonly keycloak: KeycloakService,
    @Inject(DOCUMENT)
    protected readonly document: Document,
  ) {}

  public get isAuthenticated$(): Observable<boolean> {
    return this._isAuthenticated$.pipe(shareReplay());
  }

  public get isReady$(): Observable<boolean> {
    return this.keycloak.keycloakEvents$
      .pipe(
        filter(event => event.type === KeycloakEventType.OnReady),
        mapTo(true),
      );
  }

  public setAuthState(isAuthenticated: boolean): void {
    this._isAuthenticated$.next(isAuthenticated);
  }

  public async login(): Promise<void> {
    await this.keycloak.login({
      redirectUri: this.document.location.href,
    });
  }
}
